import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import MainLayout from "./components/layout/MainLayout";
import { routes } from "./routes";
import "react-toastify/dist/ReactToastify.css";
import { MuiThemeProvider } from "@material-ui/core";
import theme from "./theme";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { useCarregarDados } from "./helper";
import { useEffect } from "react";
import { analytics, perfomance } from "./firebase-config";
import SnackRedux from "./components/Generics/SnackRedux";
import CssBaseline from "@material-ui/core/CssBaseline";

dayjs.extend(utc);
dayjs.extend(timezone);

dayjs.tz.setDefault("America/Sao_Paulo");
dayjs.locale("pt-br");

const RoutesListener = () => {
  const location = useLocation();

  useEffect(() => {
    analytics.logEvent(location.pathname);
  }, [location]);

  return <></>;
};

function App() {
  useCarregarDados();
  return (
    <MuiThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        <RoutesListener />

        <SnackRedux />

        <Routes>
          <Route path="/" element={<MainLayout />}>
            {routes}
          </Route>
        </Routes>
      </BrowserRouter>
    </MuiThemeProvider>
  );
}

export default App;
